import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { sispoliBridge } from './lib/sispoliBridge'
import OrgGuard from './components/layout/OrgGuard'
import AuthGuard from './components/layout/AuthGuard'
import AppLayout from './components/layout/AppLayout'
import LoginPage from './pages/LoginPage'
import TermsPage from './pages/TermsPage'
import DashboardPage from './pages/DashboardPage'
import MissionsPage from './pages/MissionsPage'
import MissionDetailPage from './pages/MissionDetailPage'
import LeaderboardPage from './pages/LeaderboardPage'
import ProfilePage from './pages/ProfilePage'
import ChatPage from './pages/ChatPage'
import MateriaisPage from './pages/MateriaisPage'
import ContactsPage from './pages/ContactsPage'
import BlogPage from './pages/BlogPage'
import RedeCapturePage from './pages/RedeCapturePage'
import useVersionCheck from './hooks/useVersionCheck'

// Subdomínio rede.sispoli.* → tela pública de captação da rede da liderança
const IS_REDE = typeof window !== 'undefined' && window.location.hostname.startsWith('rede.')

export default function App() {
  useVersionCheck()

  // Re-anuncia token pro app wrapper toda vez que abre — garante que
  // quem já estava logado (token já em localStorage) também tenha o
  // device registrado pra push.
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) sispoliBridge.notifyLogin(token)
  }, [])

  if (IS_REDE) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/:hash" element={<RedeCapturePage />} />
          <Route path="*" element={
            <div className="min-h-dvh flex items-center justify-center bg-gray-50 px-6 text-center">
              <div>
                <h1 className="text-xl font-bold text-gray-900 mb-2">Rede SisPoli</h1>
                <p className="text-sm text-gray-500">Use o link de cadastro que você recebeu.</p>
              </div>
            </div>
          } />
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* Valida se a org existe */}
        <Route path="/:slug" element={<OrgGuard />}>
          {/* Público */}
          <Route path="login" element={<LoginPage />} />
          <Route path="termos" element={<TermsPage />} />

          {/* Autenticado */}
          <Route element={<AuthGuard />}>
            <Route element={<AppLayout />}>
              <Route index element={<Navigate to="dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="missoes" element={<MissionsPage />} />
              <Route path="missoes/:missionId" element={<MissionDetailPage />} />
              <Route path="arsenal" element={<Navigate to="../materiais" replace />} />
              <Route path="resultados" element={<LeaderboardPage />} />
              <Route path="perfil" element={<ProfilePage />} />
              <Route path="materiais" element={<MateriaisPage />} />
              <Route path="contatos" element={<ContactsPage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog/:postSlug" element={<BlogPage />} />
              <Route path="channels/:channel" element={<ChatPage />} />
            </Route>
          </Route>
        </Route>

        {/* Root */}
        <Route path="/" element={
          <div className="min-h-dvh flex items-center justify-center bg-white px-6">
            <div className="text-center">
              <h1 className="text-xl font-bold text-gray-900 mb-2">Comunidade SisPoli</h1>
              <p className="text-sm text-gray-500">Acesse com o link da sua comunidade</p>
            </div>
          </div>
        } />
      </Routes>
    </BrowserRouter>
  )
}
